<template>
  <ag-grid-vue
    :rowData="aglist"
    :columnDefs="headers"
    :class="`${agGridTheme}`"
    :localeText="agGridLocaleText"
    :style="`height:${height || '45vh'}`"
    :defaultColDef="defaultColDef"
    :gridOptions="gridOptions"
    :rowSelection="multiple ? 'multiple':'single'"
    @selection-changed="onSelectionChanged"
    :customChartThemes="customChartThemes"
  ></ag-grid-vue>
</template>

<script>
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';
import 'ag-grid-community/dist/styles/ag-theme-balham-dark.css';
import { AgGridVue } from 'ag-grid-vue';
import { mapGetters } from 'vuex';

export default {
  name: 'SingleGrid',
  data() {
    return {
      aglist: [],
      defaultColDef: {},
      gridOptions: {},
      gridApi: {},
      customChartThemes: null,
    };
  },
  props: ['headers', 'list', 'offset', 'multiple', 'reset', 'height'],
  components: {
    AgGridVue,
  },
  computed: {
    ...mapGetters('helper', ['agGridLocaleText', 'agGridTheme']),
  },
  created() {
    this.gridOptions = {
      groupDefaultExpanded: -1,
    };
    this.defaultColDef = {
      filter: true,
      sortable: true,
      resizable: true,
      enableValue: true,
      floatingFilter: true,
    };
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
  },
  methods: {
    onSelectionChanged() {
      const selectedRows = this.gridApi.getSelectedRows();
      this.$emit('callback', selectedRows);
    },
  },
  watch: {
    list: {
      handler(list) {
        this.aglist = list;
        if (list.length > 0) {
          this.gridApi.sizeColumnsToFit();
        }
      },
      immediate: true,
    },
    reset() {
      this.gridApi.deselectAll();
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
